
const apiConfig = {
    //Local
    //apiUrl: 'https://localhost:7112/api/',
    //Live
    apiUrl: 'https://gl-api.solegaze.com/api/',
    //Demo
    //apiUrl: 'https://demo-api.solegaze.com/api/',

    apiKey: 'Lieda1002',
};

export default apiConfig;

